// import AWSAppSyncClient, { AUTH_TYPE } from 'aws-appsync';
// import Auth from '@aws-amplify/auth';
import { fetchAuthSession } from '@aws-amplify/auth';
// import {
//   Platform,
// } from 'react-native';
// import ApolloStorageBackend from './ApolloStorage';

import { ApolloClient, InMemoryCache, ApolloLink, HttpLink } from '@apollo/client';
import { createAuthLink, AUTH_TYPE } from 'aws-appsync-auth-link';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { persistCache, AsyncStorageWrapper } from 'apollo3-cache-persist';

import infraConfig from '../config.json';

const cache = new InMemoryCache();

(async () => {
  await persistCache({
    cache,
    storage: new AsyncStorageWrapper(AsyncStorage),
  });
})();

const AppSyncClientUnauthenticated = new ApolloClient({
  cache,
  link: ApolloLink.from([
    createAuthLink({
      url: infraConfig.appsyncLegacyUrl,
      region: infraConfig.region,
      auth: {
        type: AUTH_TYPE.API_KEY,
        apiKey: infraConfig.appsyncLegacyKey,
      },
    }),
    new HttpLink({ uri: infraConfig.appsyncLegacyUrl }),
  ]),
});

// const AppSyncClientUnauthenticated = new AWSAppSyncClient({
//   url: infraConfig.appsyncLegacyUrl,
//   region: infraConfig.region,
//   auth: {
//     type: AUTH_TYPE.API_KEY,
//     apiKey: infraConfig.appsyncLegacyKey,
//   },
//   // addTypename: false,
//   offlineConfig: {
//     keyPrefix: 'pub',
//   },
// });

let savedAppSyncClientAuthenticated;

const AppSyncClientAuthenticated = (user) => {
  if (!user) {
    // return AppSyncClientUnauthenticated; ????
    return undefined;
  }

  if (!savedAppSyncClientAuthenticated) {
    savedAppSyncClientAuthenticated = new ApolloClient({
      // TODO: revisit later whether we need to persist this cache too
      cache: new InMemoryCache(),
      link: ApolloLink.from([
        createAuthLink({
          url: infraConfig.appsyncLegacyUrl,
          region: infraConfig.region,
          auth: {
            type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
            jwtToken: new Promise((resolve, _reject) => {
              fetchAuthSession().then(
                ({ tokens }) => {
                  console.log('fetchAuthSession() succeeded.');
                  console.log(tokens);
                  if (!tokens || !tokens.accessToken) {
                    // reject(new Error('No access token found'));
                    resolve(undefined);
                  } else {
                    resolve(tokens.accessToken.toString());
                  }
                }
              ).catch((err) => {
                console.log('fetchAuthSession() failed.');
                console.log(err);
                // reject(err);
                resolve(null);
              });
            }),
          },
        }),
        new HttpLink({ uri: infraConfig.appsyncLegacyUrl }),
      ]),
    });
  }
  return savedAppSyncClientAuthenticated;
};

// // ApolloStorageBackend(AppSyncClient.cache);
// const AppSyncClientAuthenticated = new AWSAppSyncClient({
//   url: infraConfig.appsyncLegacyUrl,
//   region: infraConfig.region,
//   auth: {
//     type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
//     jwtToken: async () => (await Auth.currentSession()).getAccessToken().getJwtToken(),
//   },
//   // addTypename: false,
//   offlineConfig: {
//     keyPrefix: 'auth',
//   },
// });

// // The below cache seems to duplicate the one used by appsync internally and brings the non-implemented complexity of managing the quota
// // if (Platform.OS === 'web') {
// //   ApolloStorageBackend(AppSyncClientAuthenticated.cache);
// //   ApolloStorageBackend(AppSyncClientUnauthenticated.cache);
// // }

export {
  AppSyncClientAuthenticated,
  AppSyncClientUnauthenticated,
};
